import React from 'react';
import { View, Text, Pressable, StyleSheet, Platform } from 'react-native';
import { useNavigation } from '../context/NavigationContext';

const CURRENT_YEAR = new Date().getFullYear();

export default function LegalFooter() {
  const { navigateTo } = useNavigation();

  return (
    <View style={styles.footer}>
      <View style={styles.inner}>
        <Pressable
          onPress={() => navigateTo('Terms')}
          hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          style={({ hovered, pressed }) => [
            styles.linkPressable,
            Platform.OS === 'web' && hovered && styles.linkPressableHovered,
            pressed && styles.linkPressablePressed,
          ]}
        >
          {({ hovered }) => (
            <Text style={[styles.link, Platform.OS === 'web' && hovered && styles.linkHovered]}>
              Terms of Service
            </Text>
          )}
        </Pressable>
        <Text style={styles.separator}>|</Text>
        <Pressable
          onPress={() => navigateTo('Privacy')}
          hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          style={({ hovered, pressed }) => [
            styles.linkPressable,
            Platform.OS === 'web' && hovered && styles.linkPressableHovered,
            pressed && styles.linkPressablePressed,
          ]}
        >
          {({ hovered }) => (
            <Text style={[styles.link, Platform.OS === 'web' && hovered && styles.linkHovered]}>
              Privacy Policy
            </Text>
          )}
        </Pressable>
        <Text style={styles.separator}>|</Text>
        <Text style={styles.copyright}>&copy; {CURRENT_YEAR} BetOptimized LLC</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  footer: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    backgroundColor: 'transparent',
  },
  inner: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  linkPressable: {
    backgroundColor: 'transparent',
    borderRadius: 4,
    paddingVertical: 2,
    paddingHorizontal: 4,
    ...(Platform.OS === 'web' ? { cursor: 'pointer' } : {}),
  },
  linkPressableHovered: {
    backgroundColor: 'rgba(255,255,255,0.06)',
  },
  linkPressablePressed: {
    opacity: 0.85,
  },
  link: {
    color: 'rgba(255,255,255,0.35)',
    fontSize: 11,
    fontWeight: '500',
    ...(Platform.OS === 'web' ? { cursor: 'pointer' } : {}),
  },
  linkHovered: {
    color: 'rgba(255,255,255,0.65)',
    ...(Platform.OS === 'web' ? { textDecorationLine: 'underline' } : {}),
  },
  separator: {
    color: 'rgba(255,255,255,0.15)',
    fontSize: 11,
  },
  copyright: {
    color: 'rgba(255,255,255,0.25)',
    fontSize: 11,
  },
});
